import React from "react";
import jquery from "jquery";

class InfiniteScrollArticle extends React.Component {
  componentDidMount() {
    /* console.log("componentDidMount");*/

    this.pageViewTrackingSent = false;

    jquery(this.refs.article).html(this.props.html);

    this.onScroll = this.onScroll.bind(this);

    this.onScrollThrottled = _.throttle(this.onScroll, 100);

    window.addEventListener("scroll", this.onScrollThrottled);
    /* jquery(window).on('scroll', this.onScrollThrottled);*/

    this.onScroll();

    /* ReactRailsUJS.mountComponents(jquery(this.refs.article)); */
  }

  onScroll() {
    /* console.log("scrolled");*/

    var rect = this.refs.article.getBoundingClientRect();
    /* console.log("rect", rect);*/

    var windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > windowHeight) {
      /* console.log(this.props.permalink + "Is in viewport");*/

      var currentPathname = window.location.pathname;
      if (currentPathname !== this.props.permalink) {
        this.sendPageViewTracking();

        console.log("setting push state: ", this.props.permalink);
        history.pushState(null, null, this.props.permalink);
      }
    }
  }

  sendPageViewTracking() {
    /* if (this.pageViewTrackingSent) {
     *   return;
     * } */

    console.log("sendPageViewTracking");
    this.pageViewTrackingSent = true;

    // add all tracking analytics below
    var postPosition = this.props.index + 1;

    gtag('event', 'page_view', {
      page_title: this.props.title,
      page_location: window.location.origin + this.props.permalink
    });


    // This should be provided by autotrack now
    /* ga('set', 'page', this.props.permalink);
     * ga('send', 'pageview');*/

    // ga("set", "dimension1", this.props.author);
    // ga("set", "dimension2", this.props.vertical);
    // ga("set", "dimension3", this.props.category);
    // ga("set", "dimension14", this.props.article_type);

    // ga("send", {
    //   hitType: "event",
    //   eventCategory: "Article Infinite Scroll Pageview",
    //   eventLabel: "Scroll Position " + postPosition,
    //   eventValue: postPosition,
    //   eventAction: "event"
    // });

    // if (this.props.isMobile) {
    //   ga("send", {
    //     hitType: "event",
    //     eventCategory: "Recirculation",
    //     eventLabel: "Mobile Infinite Scroll",
    //     eventValue: postPosition,
    //     eventAction: "scroll"
    //   });
    // } else {
    //   ga("send", {
    //     hitType: "event",
    //     eventCategory: "Recirculation",
    //     eventLabel: "Desktop Infinite Scroll",
    //     eventValue: postPosition,
    //     eventAction: "scroll"
    //   });
    // }

    /* var url = "http://www.thefader.com"+this.props.permalink;
     * var urlref = "http://www.thefader.com"+this.props.originalPermalink;*/

    /* if (window.pSUPERFLY) {
     *   window.pSUPERFLY.virtualPage({
     *     path: this.props.permalink,
     *     title: this.props.title,
     *     authors: this.props.author,
     *     sections: this.props.sections
     *   });
     * } else {
     *   // TODO throw airbrake error
     *   console.log("DEBUG: chartbeat not loaded???");
     * }
     */
    /* ga('impressionTracker:observeElements', window.ad_ids);*/

    /* console.log("page tracking events for index sent ", postPosition);*/
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScrollThrottled);
  }

  render() {
    /* console.log("rendering article index: ", this.props.index);*/

    var recommendedSection = null;
    /* if (this.props.index === 0) {
     *   recommendedSection = <RecommendedSection isMobile={this.props.isMobile} />;
     * }*/

    var emailSection = null;
    /* if (this.props.index === 1) {
     *   emailSection = <EmailSection isMobile={this.props.isMobile} />;
     * }
     * console.log("emailSection is ", emailSection);*/

    /* return (
     *   <div>
     *     <div ref="article" />
     *     {recommendedSection}
     *     {emailSection}
     *   </div>
     * );*/

    return (
      <div>
        <div ref="article" />
      </div>
    );
  }
}

export default InfiniteScrollArticle;

/* InfiniteScrollArticle.propTypes = {
 *   isMobile: React.PropTypes.bool,
 *   html: React.PropTypes.string,
 *   permalink: React.PropTypes.string,
 *   index: React.PropTypes.number,
 * }; */
